// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      PleaseSelect: 'Please select one photo to generate your Avatar AI',
      MyProducts: 'My Products',
      Completed: 'Completed',
      SortNumber: 'Sort Number',
      Identifier: 'Phone or Email',
      Payed: 'Paid',
      NoDataAvailable: 'No Data Available',
      NoPaymentHistory: 'No Payment History',
      NoPendingPayments: 'No  Pending Payments',
      NoPaymentsDescription: 'No Payments Description',
      Customer: 'Customer',
      InvoiceNumber: 'InvoiceNumber',
      PaymentHistory: 'Payment History',
      ReadAll: 'Read All',
      Review: 'Review',
      ScheduleOfFees: 'Schedule of Fees',
      Location: 'Location',
      PhoneNumberIsRequired: 'PhoneNumber IsRequired',
      Packages: 'Packages',
      About: 'About',
      Contact: 'Contact',
      OnHold: 'On Hold',
      PayNow: 'Pay Now',
      Package: 'Package',
      Course: 'Course',
      Type: 'Type',
      Lesson: 'Lesson',
      SelectAddress: 'Select Address',
      Nationality: ' Nationality  ',
      Birthday: ' Birthday  ',
      CellPhoneNumber: ' Cell Phone Number  ',
      HomePhoneNumber: 'Home Phone Number',
      ContractNumber: 'ContractNumber',
      IsHaveGlasses: 'Is Have Glasses',
      Calculate: 'Calculate',
      Order: 'Order',
      SelectProductToPrint: 'Select Product to Print',
      YourAddresses: 'Your Addresses',
      AddNew: 'Add New',
      Address: 'Address',
      Region: 'Region',
      Address2: 'Address2',
      Subtotal: 'Subtotal',
      Shipping: 'Shipping',
      Extra: 'Extra',
      Total: 'Total',
      CreateOrder: 'Create Order',
      PleaseProvideAValidEmail: 'Please Provide AValid Email',
      CreditPoints: 'Credit Points',
      GenrationFreeTotal: 'Genration Free Total',
      CreditPointsUsed: 'Credit Points Used',
      CreditPointsHave: 'Credit Points Have',
      DoneRequestTotal: 'Done Request Total',
      PasswordIsRequired: 'Password Is Required',
      PasswordsMustmMtch: 'PasswordsMustmMtch',
      SubscEmailIsRequiredibe: 'Email Is Required',
      ResetPassword: 'Reset Password',
      Expiry: 'Expiry',
      Youraddresses: 'Your Addresses',
      ProfileSettings: 'Profile Settings',
      MyOrders: 'My Orders',
      AIPrompt: 'AI Prompt',
      SingOut: 'SingOut',
      PackagesCredit: 'Packages Credit',
      PackagesPaymentHistory: 'Packages Payment History',
      PrintOnCanvas: 'Print Cart',
      AIAvatar: 'AI Avatar',
      Uploadaphoto: 'Upload a photo of you or take a selfie to Convert to AI Avatar Instantly…',
      Print: 'Print',
      ArchivedItem: 'Archived Item',
      ActivityHistory: 'Activity History',
      ChooseGenrativeStyles: 'Choose Genrative Styles',
      UserUsedPakage: 'Show User Used Pakage',
      ProductId: 'Product Id',
      TotalPrice: 'Total Price',
      TrackingUrl: 'Tracking Url',
      OrderId: 'Order Id',
      AboutUs: 'AboutUs',
      ChooseFromPackage: 'Choose From Package',
      Tracking: 'Tracking',
      AddEditAdress: 'Add Edit Adress',
      Country: 'Country',
      Address1: 'Address1',
      Zip: 'Zip',
      Subscribe: 'Subscribe',
      AddCard: 'Add Card',
      Cvc: 'Cvc',
      Number: 'Card Number',
      Download: 'Download',
      Generate: 'Generate',
      ConfirmStyle: 'Confirm Style',
      TextGenrate: 'Type anything to generate an nft image',
      Copyrights: 'CopyRights',
      Welcome: 'Welcome',
      UserBackgroundImage: 'Background Image',
      UserImage: 'User Image',
      UserDetails: 'Update User Details',
      Newsletter: 'News Letter',
      Support: 'Support',
      ContactUs: 'Contact Us',
      PrivacyPolicy: 'Privacy Policy',
      AlreadySignedUp: 'Already Signed Up?',
      NewHere: 'New Here',
      ForgotPassword: 'Reset Password',
      LogIn: 'LogIn',
      SignUp: 'SingUp',
      Password: 'Password',
      ConfirmPassword: 'Confirm Password',
      WelcomeBack: 'Welcome Back',
      Send: 'Send',
      ForgetPassword: 'Forget Password',
      EmailIsRequired: 'Email Is Required',
      BestDayInThisYear: 'Best  Year',
      BadDayInThisYear: 'Bad    Year',
      BadDay: 'Bad Day',
      BestDay: 'Best  Day',
      BestDiffValue: 'Best Diff Value',
      BadDiffValue: 'Bad Diff Value',
      BestTipValue: 'Best Tip Value',
      BadTipValue: 'Bad Tip Value',
      BestBarValue: 'Best Bar Value',
      BadBarValue: 'Bad Bar Value',
      Today: 'Today',
      Daily: 'Daily',
      Weekly: 'Weekly',
      Monthly: 'Monthly',
      Yearly: 'Yearly',
      AutoChooseSerialNumber: 'Auto Choose Serial Number',
      SerailNumber: 'Serail Number',
      MinimumQuantity: 'MinimumQuantity',
      Dashboard: 'Dashboard',
      Quantity: 'Quantity',
      CrateionDate: 'Createion Date',
      GoToDetails: 'Go To Details',
      QuantityInStock: 'Quantity In Stock',
      Count: 'Count',
      CreateProduct: 'Create Product',
      Tax: 'Tax',
      ProductName: 'Product Name',
      Invoice: 'Invoice',
      AddProductToInvoice: 'Add Product To Invoice',
      Used: 'Used',
      NotUsed: 'Not Used',
      SerialNumber: 'Serial Number',
      Status: 'Status',
      CreationDate: 'Creation Date',
      ChooseFile: 'Choose File',
      UploadFile: 'Upload File',
      DownloadSerialNumberFile: 'Download the serial number file',
      ProblemDetail: 'Problem Detail',
      AddEditCommonMistakes: 'Add Edit Common Mistakes',
      Solution: 'Solution',
      Problem: 'Problem',
      MaterialType: 'Material Type',
      RemainedWarantyDays: 'Remained Waranty Days',
      Catalog: 'Catalog',
      Done: 'Done',
      Required: 'Required',
      NameLocale: 'Name Locale',
      SellingPrice: 'Selling Price',
      Cost: 'Cost',
      VendorInformation: 'Vendor Information',
      AddNewVendors: 'Add New Vendors',
      Vendors: 'Vendors',
      CommonMistakes: 'Common Mistakes',
      AddSerialNumbers: 'Add Serial Numbers',
      InsertSerialNumber: 'Insert Serial Number',
      FullAddress: 'Full Address',
      Value: 'Value',
      ChannelName: 'Channel Name',
      FullAdress: 'Full Address',
      Latitude: 'Latitude',
      Longitude: 'Longitude',
      State: 'State',
      AddNewContact: 'Add New Contact',
      AddNewAddress: 'Add New Address',
      CustomerInvoice: 'Customer Invoice',
      Contacts: 'Contacts',
      City: 'City',
      ACTIONS: 'ACTIONS',
      CustomerCategory: 'Customer Category',
      FirstName: 'First Name',
      CustomerNumber: 'Customer Number',
      EditCustomerInformation: 'Edit Customer Information',
      AddNewCustomerInformation: 'Add New Customer Information',
      LastName: 'Last Name',
      AddressCount: 'Address Count',
      ContactCount: 'Contact Count',
      AddNewCustomer: 'Add New Customer',
      PhoneNumber: 'Phone Number',
      CustomerLastName: 'Customer Last Name',
      AddNewInvoice: 'Add New Invoice',
      SequenceNumber: 'Sequence Number',
      CustomerName: 'Customer Name',
      TotalAmount: 'Total Amount',
      RemainingAmount: 'Remaining Amount',
      Note: 'Note',
      NumberOfOrders: 'Number Of Orders',
      AddProduct: 'Add Product',
      Search: 'Search',
      CustomerInformation: 'Customer Information',
      ProductNumber: 'Product Number',
      NameAr: 'Name Locale',
      Description: 'Description',
      Warranty: 'Warranty',
      Barcode: 'Barcode',
      Notes: 'Notes',
      Available: 'Available',
      Unavailable: 'Unavailable',
      AddCatalog: 'Add Catalog',
      AddImage: 'Add Image',
      SearchbySerialNumber: 'Search by Serial Number',
      User: 'User',
      Customers: 'Customers',
      Chat: 'Chat',
      AddService: 'Add Service ',
      SendNotification: 'Send Notification',
      UsersMobile: 'Users Mobile',
      AddSubSection: 'Add SubSection',
      DiscountValue: 'Discount Value',
      RegisteredDate: 'Registered Date',
      FullName: 'Full Name',
      Email: 'Email',
      IsActive: 'IsActive',
      DateBirth: 'DateBirth',
      Phone: 'Phone',
      Gender: 'Gender',
      Product: 'Product',
      UserName: 'UserName',
      Rate: 'Rate',
      IsVisible: 'IsVisible',
      comments: 'comments',
      OrderCode: 'Order Code',
      Date: 'Date',
      Section: 'Section',
      SelectUser: 'Select User',
      SubSection: 'Sub Section',
      Time: 'Time',
      Services: 'Services',
      Price: 'Price',
      SubCategory: 'Sub Category',
      Comments: 'Comments',
      Settings: 'Settings',
      Reports: 'Reports',
      Service: 'Service',
      Img1: 'Img1',
      Img2: 'Img2',
      Img3: 'Img3',
      Img4: 'Img4',
      Category: 'Category',
      Name: 'Name',
      AddSubCategory: 'Add SubCategory',
      Image: 'Image',
      Sliders: 'Sliders',
      Invoices: 'Invoices',
      Actions: 'Actions',
      Text: 'Text',
      Title: 'Title',
      Sections: 'Sections',
      Categories: 'Categories',
      Offers: 'Offers',
      Teams: 'Teams',
      Home: 'Home',
      Clinic: 'Clinic',
      Orders: 'Orders',
      Products: 'Products',
      Messages: 'Messages',
      Dates: 'Dates',
      Users: 'Users',
      AreYouSure: 'Are you sure',
      YouWillNotAble: 'You will not be able to recover this imaginary file!',
      Warning: 'Warning',
      YesDelete: 'Yes, delete it!',
      NoKeep: 'No, keep it',
      Deleted: 'Deleted!',
      YourFileDeleted: 'Your imaginary file has been deleted.!',
      Cancelled: 'Cancelled',
      YourImaginarySafe: 'Your imaginary file is safe',
      SomethingWentWrong: 'Something Went Wrong',
      RemovedSuccessfully: 'Removed successfully',
      UpdatedSuccessfully: 'Updated successfully',
      AddedSuccessfully: 'Added successfully',
      DASHBOARD: 'Dashboard',
      Cancel: 'Cancel',
      Save: 'Save',
      Back: 'Back',
      Reset: 'Reset',
      Edit: 'Edit',
      Create: 'Create',
      Correct: 'Correct',
      IsRequired: 'Is Required',
      ButThisAlreadyAdded: 'But this already added',
      IsDeleting: 'Is Deleting...',
      Delete: 'Delete',
      DeletePermanently: 'Are you sure to permanently delete this row?',
      EndDate: 'End Date',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: 'Don\'t have an account?',
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.'
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username'
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      }
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields'
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created'
        }
      }
    }
  }
};
